import { ConditionValueLibraryGroups } from "./condition-value-library-groups"
import { getScheduleLibraryFolders } from "./controller/get-schedule-library-folders"

export function ConditionValueScheduleLibraryFolder(props) {
    return (
        <ConditionValueLibraryGroups
            {...props}
            loadOptions={getScheduleLibraryFolders}
            placeholder="Select schedule library folders..."
        />
    )
}
